module.exports = __webpack_public_path__ + "static/media/Cv Mgazine.13a94292.pdf";